const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Chinese%20man%20with%20friendly%20expression%2C%20warm%20lighting%2C%20simple%20dark%20background%2C%20professional%20headshot%20style%2C%20clean%20and%20modern&width=100&height=100&seq=avatar-01&orientation=squarish',
    name: '星辰大海',
    date: '2小时前',
    content: '91电影真的太良心了！不用注册就能免费看，片源更新也很快，每天下班回来都能找到新片看，强烈推荐给喜欢看电影的朋友们。',
    film: '在看《孤胆狙击》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20Chinese%20woman%20with%20warm%20smile%2C%20soft%20golden%20lighting%2C%20simple%20dark%20background%2C%20elegant%20headshot%20style%2C%20natural%20and%20approachable&width=100&height=100&seq=avatar-02&orientation=squarish',
    name: '小雨淅淅',
    date: '5小时前',
    content: '找了好久终于找到能免费看国产电影的地方了！画质清晰不卡顿，手机上看也很流畅，已经安利给身边所有朋友了。',
    film: '在看《长安十二夜》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20middle-aged%20Chinese%20man%20with%20glasses%2C%20warm%20professional%20lighting%2C%20simple%20dark%20background%2C%20confident%20headshot%20style%2C%20clean%20composition&width=100&height=100&seq=avatar-03&orientation=squarish',
    name: '电影老炮',
    date: '8小时前',
    content: '作为一个看了二十年电影的老影迷，这个平台的片库确实不错。分类清晰，更新及时，重点是完全免费，很难得。',
    film: '在看《逆流而上》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Chinese%20woman%20with%20stylish%20look%2C%20warm%20cinematic%20lighting%2C%20simple%20dark%20background%2C%20modern%20headshot%20style%2C%20confident%20expression&width=100&height=100&seq=avatar-04&orientation=squarish',
    name: '追剧小达人',
    date: '12小时前',
    content: '周末在家刷了一整天91电影！科幻片和悬疑片特别全，画质也没得说，已经成了我的周末固定节目。',
    film: '在看《机甲风暴2046》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20Chinese%20man%20with%20casual%20style%2C%20warm%20relaxed%20lighting%2C%20simple%20dark%20background%2C%20natural%20headshot%20style%2C%20friendly%20and%20genuine&width=100&height=100&seq=avatar-05&orientation=squarish',
    name: '光影随行',
    date: '1天前',
    content: '没想到国产电影现在这么好看！91电影上资源特别全，而且完全免费的体验真的很棒，希望一直保持下去。',
    film: '在看《山海传说》',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            影迷热评
          </h2>
          <p className="text-foreground-500 text-sm">来自真实观众的声音</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className={`bg-background-100 rounded-xl p-5 ${
                idx >= comments.length - 2 ? 'lg:col-span-1' : ''
              } ${idx === comments.length - 1 ? 'sm:col-span-2 lg:col-span-1' : ''}`}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-950 truncate">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.date}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{item.content}</p>
              <span className="inline-block px-3 py-1 rounded-full bg-secondary-500/10 text-secondary-400 text-xs">
                {item.film}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}